import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('token'); // Or however you store the login token

  return isLoggedIn ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
